import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { getFileExtension } from '../../utils/common';
import { useTranslation } from 'react-i18next';

const PreviewModal = ({ isOpen, handleCancel, url }) => {
  const extension = getFileExtension(url);
  const { t } = useTranslation();

  const renderPreview = () => {
    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
      return (
        <div className="preview-img">
          <img src={url} alt="preview" />
        </div>
      );
    }

    if (extension === 'pdf') {
      return <iframe src={url} title="PDF Preview" className="preview-pdf" />;
    }

    return <p>{t('unsupportedFileType')}</p>;
  };

  return (
    <Modal
      isOpen={isOpen}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
      toggle={handleCancel}>
      <ModalHeader toggle={handleCancel} className="d-flex justify-content-center fs-6">
        {t('filePreview')}
      </ModalHeader>
      <ModalBody>{renderPreview()}</ModalBody>
    </Modal>
  );
};

PreviewModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func,
  url: PropTypes.string.isRequired
};

export default PreviewModal;
